import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export default function AccountWorkoutsLayout({}) {
  const location = useLocation();
  const navigate = useNavigate();
  const categoryName = location.pathname.split("/").pop();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (categoryName == "Workouts") {
      navigate(location.pathname + "/Workout");
    }
  }, [location.pathname]);

  return (
    <>
      <Outlet />
    </>
  );
}
